import moment from 'moment';

/**
 * Resolve the CTA label for a closed trip result row.
 * Priority: departed → sold out → generic closed.
 * @param {Function} t - i18next translate function.
 * @param {object} params - departure, availability.
 * @param {string|Date|import('moment').Moment} params.departure - Trip departure instant.
 * @param {number} params.availability - Remaining seat count from the trip payload.
 * @returns {string} Translated button text.
 */
const getClosedTripButtonText = (t, { departure, availability }) => {
  if (moment(departure).isBefore(moment())) return t('general:trip_departed');

  if (availability === 0) return t('general:trip_sold_out');

  return t('general:trip_closed');
};

export default getClosedTripButtonText;
